module.exports = __webpack_public_path__ + "static/media/video-editor.5406d576.webp";